import { Option, PaginationType } from "@shared/types"
import { FLEET_VIEW_TYPES } from "./fleet-shared.const"


export const BooleanOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

export const booleanFilterOptions: Option[] = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
]

export const BooleanStatusOptions = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false },
]

export const CLIENT_ENV_URLS = {
  LOCAL: 'http://localhost:4200/client-auth',
  SIT: 'https://fd-sit-flydocs-website.azurewebsites.net/client-auth',
  UAT: 'https://web.flydocsuat.com/client-auth',
  PROD: 'https://www.myflydocs.com/client-auth',
}

export enum COPY_MOVE_FIELDS_FILTER_VIEW_TYPES {
  MH_FOLDER = 'MH_FOLDER',
  OPEN_FOLDER = 'OPEN_FOLDER',
}

export enum CATEGORY_MASTER_CENTRE_TYPE {
  AIRCRAFT = 'AIRCRAFT',
  ENGINE = 'ENGINE',
  ENGINE_STAND = 'ENGINE_STAND',
  PROPELLER = 'PROPELLER',
  APU = 'APU',
  LANDING_GEAR = 'LANDING_GEAR',
}

export const centreOptions: Option<FLEET_VIEW_TYPES>[] = [
  { label: 'Aircraft', value: FLEET_VIEW_TYPES.AIRCRAFT },
  { label: 'Engine', value: FLEET_VIEW_TYPES.ENGINE },
  { label: 'Landing Gear', value: FLEET_VIEW_TYPES.LANDING_GEAR },
  { label: 'APU', value: FLEET_VIEW_TYPES.APU },
  { label: 'Thrust Reverser', value: FLEET_VIEW_TYPES.THRUST_REVERSER },
  { label: 'Propeller', value: FLEET_VIEW_TYPES.PROPELLER },
]

export enum ACTION_TYPES {
  ATTACH = 'ATTACH',
  COPY = 'COPY',
  MOVE = 'MOVE',
  ADD = 'ADD',
  DELETE = 'DELETE',
  RESET = 'RESET',
  /// other action will be added here
}

export enum FILE_ORDER_BY {
  FILE_NAME = 'FILE_NAME',
  FILE_TYPE = 'FILE_TYPE',
  FILE_SIZE = 'FILE_SIZE',
  FILE_ID = 'FILE_ID',
  FILE_ORDER = 'FILE_ORDER',
  MCC_ROWS = 'MCC_ROWS',
  REFERENCE_NUMBER = 'REFERENCE_NUMBER',
  MANAUL = 'MANAUL',
}

export enum FILE_ORDER_BY_MAPPER {
  FILE_ORDER = 0,
  FILE_ID = 1,
  FILE_NAME = 2,
  MCC_ROWS = 3,
}

/** Key will help you to identify the backend value */
export enum TRANSLATION_CATEGORIES {
  BUTTON_TEXT = 'buttonText',
  NAVIGATION_TEXT = 'navigationText',
  PAGE_TEXT = 'onPagetext',
}

/** this will help to make text common */
export enum DEFAULT_TRANSLATION_KEYS {
  ADD = 'ADD',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  AUDIT_TRAIL = 'AUDIT TRAIL',
  RESET = 'RESET',
  SAVE = 'SAVE',
  FILTER = 'FILTER',
  EXPORT = 'EXPORT',
  CLOSE = 'CLOSE',
  MOVE = 'MOVE',
  ATTACH = 'ATTACH',
}

export const defaultPagination: PaginationType = {
  page: 1,
  perPage: 100,
  totalCount: 0,
}

/** Please dont alter the width; if needed just override it by destructuring it */
export const commonViewIconCol = {
  header: 'View',
  field: 'view',
  isView: {
    key: 'view',
    src: '/assets/images/icons/search.svg',
  },
  isSearchHidden: true,
  width: '80px',
}

export enum COMMON_AND_OR_VALUE {
  AND = 'AND',
  OR = 'OR',
}

export const commonAndOrOptionList: Option<COMMON_AND_OR_VALUE>[] = [
  {
    label: 'AND',
    value: COMMON_AND_OR_VALUE.AND,
  },
  {
    label: 'OR',
    value: COMMON_AND_OR_VALUE.OR,
  },
]

export const textareaMaxCharacters = 500

export const COMMON_SAVE_ROW_COL = {
  field: 'save',
  header: 'Save Row',
  isSearchHidden: true,
  width: '60px',
  viewCustomImgSrc: true,
}

export const COMMON_SAVE_ROW_HEADER = {
  field: '',
  header: '',
  isSearchHidden: true,
  isChildrenHeader: [COMMON_SAVE_ROW_COL],
}

export enum ROW_FILTER {
  SHOW_ALL = 'SHOW_ALL',
  HIDE_DELETED = 'HIDE_DELETED',
  SHOW_DELETED = 'SHOW_DELETED',
}

export enum COMMON_ACTIVE_INACTIVE_VALUE {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum COMMON_YES_NO_VALUE {
  YES = 'YES',
  NO = 'NO',
}

export enum COMMON_EXACT_PARTIAL_VALUE {
  EXACT = 'EXACT',
  PARTIAL = 'PARTIAL',
}

export enum COMMON_FIRST_LAST_VALUE {
  FIRST = 'FIRST',
  LAST = 'LAST',
}

export enum COMMON_DEFAULT_ALL_VALUE {
  DEFAULT = 'DEFAULT',
  ALL = 'ALL',
}

export enum COMMON_RUN_OPTION_VALUE {
  ALWAYS_ON = 'ALWAYS_ON',
  ON_DEMAND = 'ON_DEMAND',
}

export const CONST_CS_AUTO_ATTACH_WORK_STATUS_KEY_LABEL = 'work status'
export const CONST_CS_AUTO_ATTACH_WORK_STATUS_KEY = 'status_docs'
export const CONST_WORK_STATUS_ID = 'work_status_id'
export const CONST_PRIORITY_ID = 'priority'
export const CONST_CS_GRID_CUSTOM_TEMP = {
  IMAGE_TP: 'IMAGE_TP',
}

export const CONST_CS_TAB_ID_DELIVERY_BIBLE = 'a6a9636c-f24f-4470-9b2a-117939e1be88' // tabId = 12 in classic
export const CONST_RETURN_PROJECT_MANAGEMENT = 'ae9377f3-05aa-45b1-9f8e-923baf2df0f5' // tabId = 47 in classic

export enum SHOW_VISIBLITY_FILTER_VALUE {
  SHOW_ALL = 'Show All',
  HIDE_DELETED = 'Hide Deleted',
  SHOW_DELETED = 'Show Deleted',
  SHOW_FLAGGED = 'Show Flagged',
  HIDE_FLAGGED = 'Hide Flagged',
}

export enum ENUM_MODULE_MANAGEMENT_LEVEL {
  FLEET_MANAGEMENT = 'FLEET_MANAGEMENT',
  TECHNICAL_MANAGEMENT = 'TECHNICAL_MANAGEMENT',
}

export enum ENUM_MODULE_MANAGEMENT_CENTRE {
  MAINTENANCE_CONTROL_CENTRE = 'MAINTENANCE_CONTROL_CENTRE',
  DOCUMENT_MANAGEMENT_CENTRE = 'DOCUMENT_MANAGEMENT_CENTRE',
}

export const CONST_FORBIDDEN_CS_TABS_FILTERS = [
  'Aircraft Profile',
  'Engine Profile',
  'Gear Profile',
  'APU Profile',
  'Propeller Profile',
]
export const CONST_SELECT_ALL_KEY = 'SELECT_ALL'

export const CONST_VOID_KEY = 'EMPTY'

export const getCustomLabelOption = (label: string) => ({
  label,
  value: CONST_SELECT_ALL_KEY,
})

export const showAllOption = {
  label: 'Show All',
  value: CONST_SELECT_ALL_KEY,
}

export const selectAllOption = {
  label: 'Select All',
  value: CONST_SELECT_ALL_KEY,
}

export enum MMD_DEFAULT_VIEW_TYPE {
  MMD = 'MMD',
}

export enum MMD_RESPONSE_VIEW {
  GRID_VIEW = 'GRID_VIEW',
  DROPDOWN_VIEW = 'DROPDOWN_VIEW',
}

export enum COLUMN_FIELD_TYPE {
  NONE = 'NONE',
  FREE_TEXT = 'FREE_TEXT',
  LIST_OF_VALUES = 'LIST_OF_VALUES',
  DATE_PICKER = 'DATE_PICKER',
  IMAGE = 'IMAGE',
}

export enum COLUMN_FIELD_TYPE_VALUE {
  NONE = 'None',
  FREE_TEXT = 'Free Text',
  LIST_OF_VALUES = 'List of Values',
  DATE_PICKER = 'Date Picker',
}

export const USER_LOGOUT_ENDPOINTS = {
  USER: '/auth/login',
  CLIENT: '/clients/login',
}

export const MONTHS: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
